import * as wireEntities from "../protocol/wire-entities";
import { Call } from "./call";
import { ArtichokeApi } from "../artichoke/artichoke-api";
import { RTCPoolRepository } from "../rtc/rtc-pool-repository";
import { RecordingRTCPoolRepository } from "../rtc/recording-rtc-pool-repository";
import { LoggerFactory } from "../logger/logger-factory";
import { MediaTrackOptimizer } from "../rtc/media-track-optimizer";
// import { JanusService } from '../janus/janusService';

export class CallFactory {
  constructor(
    private loggerFactory: LoggerFactory,
    private artichokeAPI: ArtichokeApi,
    private rtcPoolRepository: RTCPoolRepository,
    private recordingRtcPoolRepository: RecordingRTCPoolRepository,
    private mediaTrackOptimizer: MediaTrackOptimizer // private janusService: JanusService,
  ) {}

  public create(
    call: wireEntities.Call,
    tracks?: ReadonlyArray<MediaStreamTrack>
  ): Call {
    const pool = this.rtcPoolRepository.getRtcPoolInstance(
      call.id,
      call.recordingEnabled
    );
    const recordingPool = call.recordingEnabled
      ? this.recordingRtcPoolRepository.getRecordingRtcPoolInstance(call.id)
      : undefined;

    return new Call(
      call,
      this.loggerFactory.create(`Call(${call.id})`),
      this.mediaTrackOptimizer,
      this.artichokeAPI,
      pool,
      recordingPool,
      /*this.janusService,*/ tracks
    );
  }
}
